import * as React from 'react';
import { installGlobalErrorListeners } from '../../utilities/global-error-boundary';

/**
 * CoreComponent component
 * @extends {React.PureComponent<IScriptInjectorProps>}
 */
declare global {
    interface Appcues {
        identify(userId: string, opts?: string | { language?: string; [key: string]: any }): void;
    }

    interface Window {
        Appcues?: Appcues;
    }
}

if (typeof window !== 'undefined') {
    installGlobalErrorListeners();
}

class Master extends React.PureComponent {
    public render(): JSX.Element | null {
        return <script />;
    }
}

export default Master;
